var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketsInforme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.59 34.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 12.96,
    cy: 7.57,
    rx: 6.14,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.87,17.61h-7.82c-4.72,0-8.55,3.83-8.55,8.55v6.47c0,.8.65,1.45,1.45,1.45h22.21c.8,0,1.45-.65,1.45-1.45v-3.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.84,
    y1: 27.1,
    x2: 19.84,
    y2: 34.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.8,
    y1: 27.1,
    x2: 5.8,
    y2: 33.79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.1,22.53l-2.65-1.71c-1.34-.86-1.44-1.91-1.44-3.07v-3.72h0c1.37-.28,2.67-.86,3.79-1.7l.3-.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.1,22.53l2.65-1.71c1.34-.86,1.44-1.91,1.44-3.07v-3.72s0,0,0,0c-1.37-.28-2.67-.86-3.79-1.7l-.3-.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.71,
    y: 14.46,
    width: 0.78,
    height: 5.43,
    rx: 0.39,
    ry: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 27.1,
    cy: 17.32,
    r: 8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsInforme);
export default __webpack_public_path__ + "static/media/TicketsInforme.9e01d5a20c98fa277f6303207604d3e5.svg";
export { ForwardRef as ReactComponent };